/**
 * base64エンコード/デコードした文字列を返す
 * @param  {String}  string   [description]
 * @param  {Boolean} isDecode [description]
 * @return {String}           [description]
 */
export const getBase64ConvertedString = (string, isDecode)=> {
  // const ENCODE_API_URL = 'http://localhost:5001/sound-player-sample/us-central1/encode';
  // const DECODE_API_URL = 'http://localhost:5001/sound-player-sample/us-central1/decode';

  /* cli ver */
  const Base64 = {
    encode: function(str) {
      return btoa(unescape(encodeURIComponent(str)));
    },
    decode: function(str) {
      return decodeURIComponent(escape(atob(str)));
    }
  };
  const convert = (isDecode) ? Base64.decode : Base64.encode;
  return new Promise(function(resolve, reject) {
    let converted;
    try {
      converted = convert(string);
    }
    catch (e) {
      reject({
        title: "CONVERT ERROR",
        text: "文字列変換に失敗しました",
        icon: "error",
      });
    }
    resolve(converted);
  });

  /* server gzip+base64 */
  // const queryURL = (isDecode) ? DECODE_API_URL : ENCODE_API_URL
  // return fetch(queryURL, {
  //   method : 'POST',
  //   body : string,
  // }).then(response => {
  //   return response.text();
  // });

  // /* simple euc/duc */
  // const convert = (isDecode) ? decodeURIComponent : encodeURIComponent;
  // return new Promise(function(resolve, reject) {
  //   resolve(convert(string));
  // });
};

/**
 * createTwitterShareLink
 * @param  {String} text
 * @param  {String} url
 * @param  {Array} hashtags
 * @return {String} Twitter share URL
 */
export const createTwitterShareLink = (text, url, hashtags)=> {
  const BASE_URL = 'https://twitter.com/share';
  const euc = encodeURIComponent;
  let queries = [
    `text=${euc(text)}`
  ];
  if (url) queries.push(`url=${euc(url)}`);
  if (hashtags) queries.push(`hashtags=${euc(hashtags.join(','))}`);

  return `${BASE_URL}?${queries.join('&')}`;
};


// WEBPACK FOOTER //
// ./src/Utils.js